import { render } from "./MfaSetup.vue?vue&type=template&id=496de82b"
import script from "./MfaSetup.vue?vue&type=script&lang=js"
export * from "./MfaSetup.vue?vue&type=script&lang=js"

import "./MfaSetup.vue?vue&type=style&index=0&id=496de82b&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
